// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RestOutlinedSvg from "@fishx/icons-svg/es/asn/RestOutlined";
import FishxIcon from '../components/FishxIcon';

var RestOutlined = function RestOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RestOutlinedSvg
  }));
};

RestOutlined.displayName = 'RestOutlined';
export default React.forwardRef(RestOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RestOutlined.js
// module id = 4001
// module chunks = 0